import { useRef } from "react";
import { formatCountdown, renderTypeMapEnums } from "./utils";
import { useGoodsFocus } from "../tab-goods-content/GoodsFocusContext";
import { GoodsItem, GoodsGroup } from "../../types";
import { useUserContext } from "../../routes/home/userContext";
import { useServerClock } from "@/hooks/useServerTimeSync";
import { getRemainingSeconds } from "@/utils/server-time";
// 各组件的样式已在其各自文件中导入

const GeneralGoodsItem = ({
  goodItem, // 商品信息
  index,
  showTriangle = true,
  doBuyMemberGoods,
  type = "SMALL_GOODS",
}: {
  goodItem: GoodsItem;
  index: number;
  showTriangle?: boolean;
  doBuyMemberGoods?: (goodItem: GoodsItem) => void;
  type?: keyof typeof renderTypeMapEnums;
}) => {
  const { focusedGoods, setFocusedGoods, currentGroups } = useGoodsFocus();
  const { levelInfo, balanceCredit } = useUserContext();
  const { monotonicNow } = useServerClock();
  // 后端下发的是剩余时长，使用不受系统时间和校时 offset 变化影响的单调时钟
  const seckillEndAtRef = useRef<{
    duration: number | undefined;
    endAt: number | null;
  }>({ duration: undefined, endAt: null });

  const isSeckill = goodItem?.discountType === "SECONDS_KILL_PRICE";
  const isDiscount =
    goodItem?.discountType !== "ORIGINAL_PRICE" &&
    goodItem?.salePrice !== goodItem?.discountBuyPrice;

  const isCarOwner = levelInfo?.memberType === 1;
  const showCreditPrice = isCarOwner || (!isCarOwner && balanceCredit > 0);

  // 使用共享快照中的单调时间，避免校时 offset 变化导致剩余时长跳变。
  const duration = goodItem?.secondsKillEndLastMillis;
  if (seckillEndAtRef.current.duration !== duration) {
    seckillEndAtRef.current = {
      duration,
      endAt: duration ? monotonicNow + duration : null,
    };
  }
  const remainingSeconds = seckillEndAtRef.current.endAt
    ? getRemainingSeconds(seckillEndAtRef.current.endAt, monotonicNow)
    : 0;
  const countdown = seckillEndAtRef.current.endAt
    ? formatCountdown(remainingSeconds * 1000)
    : "";

  if (!goodItem) return null;

  const RenderComponent = renderTypeMapEnums[type] as React.ComponentType<{
    goodItem: GoodsItem;
    index: number;
    showTriangle: boolean;
    active: GoodsItem | null;
    activeChange: (active: GoodsItem | null) => void;
    doBuyMemberGoods?: (goodItem: GoodsItem) => void;
    type: keyof typeof renderTypeMapEnums;
    isSeckill: boolean;
    countdown: string;
    currentGroups: GoodsGroup[];
    isDiscount: boolean;
    showCreditPrice: boolean;
  }>;
  return (
    <RenderComponent
      goodItem={goodItem}
      index={index}
      showTriangle={showTriangle}
      active={focusedGoods}
      activeChange={setFocusedGoods}
      doBuyMemberGoods={doBuyMemberGoods}
      type={type}
      isSeckill={isSeckill}
      countdown={countdown}
      currentGroups={currentGroups}
      isDiscount={isDiscount}
      showCreditPrice={showCreditPrice}
    />
  );
};
export default GeneralGoodsItem;
